import React from "react";
import { Dropdown } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { HOME_PAGE_ROUTE, JOBS_ROUTE } from "../../app/api/routeConstants";
import { NAVBAR_STYLES } from "../../css/styles";
import { useHistory, useLocation } from "react-router-dom";
import { getJobs } from "../jobs/jobsSelectors";
import { HR_ALL_MODE, HR_HEALTHCARE_MODE } from "../modes/constants";
import { resetJobFilters, setHrMode } from "../jobs/jobsActions";
import { getParamsMode } from "../jobs/helpers/jobsUrlParams";
import { getMap } from "../map/mapSelector";
import ReactGA from "react-ga4";

export default function JobsModeSelector({
  navbar,
  textColour = "white",
  postHandleClick = () => {},
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { pathname } = useLocation();
  const { isCookieConsent, responsive } = useSelector((state) => state.app);
  const { mode } = useSelector((state) => getJobs(state));
  const { coverage } = useSelector((state) => getMap(state));

  function handleClick(value) {
    if (isCookieConsent) {
      ReactGA.event({
        category: "Jobs - Selector",
        action: `mode: ${value}`,
      });
    }
    dispatch(resetJobFilters());
    dispatch(setHrMode(value));
    history.push(
      JOBS_ROUTE +
        `?mode=${getParamsMode(value)}&country=${coverage.countryCode}`
    );
    postHandleClick();
  }

  const modeOptions = [
    {
      key: 1,
      value: HR_ALL_MODE,
      text: (
        <div
          className={"nav-selector-link-menu-item"}
          onClick={() => handleClick(HR_ALL_MODE)}
        >
          All
        </div>
      ),
      active: false,
      selected: mode === HR_ALL_MODE,
    },
    {
      key: 2,
      value: HR_HEALTHCARE_MODE,
      text: (
        <div
          className={"nav-selector-link-menu-item"}
          onClick={() => handleClick(HR_HEALTHCARE_MODE)}
        >
          Hello Radius Healthcare{" "}
          <span
            className={"healthcare-text"}
            style={{
              marginLeft: 5,
              fontSize: 15,
              display: responsive.isMobile ? "block" : "inline",
            }}
          >
            New
          </span>
        </div>
      ),
      active: false,
      selected: mode === HR_ALL_MODE,
    },
  ];

  return (
    <div
      className={
        (!responsive.isComputer && " ") ||
        (pathname === HOME_PAGE_ROUTE &&
        navbar === NAVBAR_STYLES.navbarTransparent
          ? "navbar-text-transparent-link"
          : "navbar-text-link")
      }
    >
      <Dropdown
        text={"Jobs"}
        options={modeOptions}
        className="nav-selector-link"
        style={{
          padding: 0,
          fontSize: 16,
          fontFamily: "Lato, sans-serif",
          color: textColour,
          fontWeight: 400,
        }}
        // onChange={(e, d) => handleClick(d.value)} on change fails because it does not allow simult clicks on item
        // className={isOpen ? "nav-selector-open" : "nav-selector"}
        // open={false}
        // open={isOpen}
        // onChange={(e, { value }) => handleChange(e, { value })}
        // onClick={() => setIsOpen(!isOpen)}
        // onClick={(event, data) => handleSelectCountry()}
        // onChange={(e, d) => console.log("change")}
      />
    </div>
  );
}
